// import { Link } from "react-router-dom";
// import styled from "styled-components";
// import { IMedia } from "../../types/types";
// import { Title } from "glamorous";
import { IHomeSlide } from "../../types/home_slider";
import { Card, Col, Row } from "react-bootstrap";

const AnnouncementSliderComponent = ({ ...props }) => {
  //   const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });

  return (
    <Row xs={1} md={2} className="g-4">
      {props.slides.map((slideRow: IHomeSlide) => (
        <Col>
          <Card className="mb-4 shadow-sm">
            <Card.Img
              className="bd-placeholder-img card-img-top"
              width="100%"
              height="625"
              role="img"
              aria-label="Placeholder: Thumbnail"
              variant="top"
               src={`${process.env.REACT_APP_CMS}${slideRow?.attributes.Image?.data?.attributes?.url ?? ''}`}

            />

            <Card.Body>
              <Card.Text>{slideRow.attributes.Title}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default AnnouncementSliderComponent;
